<div class="container-fluid">
  <app-pagetitle
    title="Hourly Production Reports"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>
  <div class="row">
    <div class="col-xl-12">
      <div class="row">
        <div class="col-md-2">
          <div class="form-group">
            <label>Department</label>
            <select
              class="form-control custom-select"
              (ngModelChange)="select_Department($event)"
              name="departmentName"
              id="departmentName"
              ngModel
              disableOptionCentering
              [(ngModel)]="selectedDepartment"
            >
              <option
                *ngFor="let department of departmentData"
                [ngValue]="department.departmentName"
              >
                {{ department.departmentName }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>Machine</label>
            <select
              class="form-control custom-select"
              (ngModelChange)="select_Machine($event)"
              name="machineName"
              id="machineName"
              ngModel
              disableOptionCentering
              [(ngModel)]="selectedMachine"
            >
              <option
                *ngFor="let machines of filterMachine"
                [ngValue]="machines.deviceName"
              >
                {{ machines.deviceName }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group col-md-2">
          <label>Shift</label>
          <select
            class="form-control custom-select"
            name="shiftName"
            id="shiftName"
            ngModel
            disableOptionCentering
            (ngModelChange)="select_Shift($event)"
            [(ngModel)]="selectedShift"
          >
            <option *ngFor="let shift of shiftData" [ngValue]="shift.shiftName">
              {{ shift.shiftName }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-2">
          <label>Date</label>
          <input
            class="form-control"
            type="date"
            (ngModelChange)="select_Date($event)"
            [(ngModel)]="fromDate"
            placeholder="{{ 'From-date' }}"
            id="example-date-input"
            [min]="mindate"
            [max]="maxdate"
          />
        </div>
        <!-- <div class="col-md-2" *ngIf="partData.length">
          <div class="form-group">
            <label>Parts</label>
            <select class="form-control custom-select" (ngModelChange)="select_parts($event)" name="partName"
              id="partName" ngModel disableOptionCentering [(ngModel)]="selectedParts">
              <option *ngFor="let data of partData" [ngValue]="data.partName">
                {{ data.partName }}
              </option>
            </select>
          </div>
        </div> -->
        <div class="col-md-1">
          <button
            style="width: 100%; margin-top: 1.8rem"
            type="button"
            class="btn btn-success btn-rounded"
            (click)="getData()"
          >
            Submit
          </button>
        </div>
        <div
          class="col-md-1"
          *ngIf="showTable && tablehourlyData[0]?.partwiseData?.length > 0"
        >
          <button
            type="button"
            style="width: 100%; margin-top: 1.8rem"
            class="btn btn-primary btn-rounded"
            (click)="openModal(templatepdf, 'downloadpdfcsv', 'Export')"
          >
            Export
          </button>
        </div>
        <div
          class="col-md-1 mt-2 d-flex align-items-center"
          *ngIf="showTable && tablehourlyData[0]?.partwiseData?.length > 0"
        >
          <div
            (click)="openModal(templateallpdf, 'downloadpdfcsv', 'Export')"
            title="All Machine Download"
            style="
              width: 36px;
              height: 36px;
              background-color: #ffc107;
              border-radius: 10%;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            "
          >
            <i
              class="ri-folder-download-line"
              style="font-size: 20px; color: #000"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="form-group col-md-3">
            <label for="machines">Machines</label>
            <ng-multiselect-dropdown [placeholder]="'Select Machine'" [settings]="settings" [data]="dropdownList"
              [(ngModel)]="selectedMachines" (onSelect)="onMachineSelect()" (onDeSelect)="onMachineSelect()"
              (onSelectAll)="onMachineSelect($event)" (onDeSelectAll)="onMachineSelect($event)">
            </ng-multiselect-dropdown>
          </div>
          <div class="chart-scroll">
            <div [options]="machineChart" class="demo-chart1" echarts></div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="row">
    <div class="col-md-3">
      <div class="card">
        <div class="card-body">
          <div
            [options]="oeeChart"
            (chartInit)="onoeeChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 150px"
            echarts
          ></div>
        </div>
      </div>
    </div>
    <div class="col-md-9">
      <div class="card">
        <div class="card-body">
          <div
            [options]="hourlyOee"
            (chartInit)="onoeehourlyChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 150px"
            echarts
          ></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-9 d-flex flex-column">
      <div class="row row-cols-1 row-cols-md-5 g-3">
        <div class="col">
          <div class="card">
            <div
              class="card-body d-flex justify-content-around align-items-center"
            >
              <i class="mdi mdi-calendar-check mdi-36px text-primary"></i>
              <div>
                <h6 class="fw-bold mb-1">
                  {{
                    tablehourlyData &&
                    tablehourlyData.length > 0 &&
                    tablehourlyData[0].Partplanned != null
                      ? tablehourlyData[0].Partplanned
                      : 0
                  }}
                </h6>
                <p class="form-label mb-0">Planned</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card">
            <div
              class="card-body d-flex justify-content-around align-items-center"
            >
              <i class="mdi mdi-factory mdi-36px text-success"></i>
              <div>
                <h6 class="fw-bold mb-1">
                  {{
                    tablehourlyData &&
                    tablehourlyData.length > 0 &&
                    tablehourlyData[0].PartProduced != null
                      ? tablehourlyData[0].PartProduced
                      : 0
                  }}
                </h6>
                <p class="form-label mb-0">Produced</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card">
            <div
              class="card-body d-flex justify-content-around align-items-center"
            >
              <i class="mdi mdi-close-circle mdi-36px text-danger"></i>
              <div>
                <h6 class="fw-bold mb-1">
                  {{
                    tablehourlyData &&
                    tablehourlyData.length > 0 &&
                    tablehourlyData[0].PartRejected != null
                      ? tablehourlyData[0].PartRejected
                      : 0
                  }}
                </h6>
                <p class="form-label mb-0">Rejected</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card">
            <div
              class="card-body d-flex justify-content-around align-items-center"
            >
              <i class="mdi mdi-timer-off mdi-36px text-secondary"></i>
              <div>
                <h6 class="fw-bold mb-1">
                  {{
                    tablehourlyData &&
                    tablehourlyData.length > 0 &&
                    tablehourlyData[0].Downtime != null
                      ? formatMinutesToHHMMSS(tablehourlyData[0].Downtime)
                      : "00:00:00"
                  }}
                </h6>
                <p class="form-label mb-0">Downtime</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card">
            <div
              class="card-body d-flex justify-content-around align-items-center"
            >
              <i class="mdi mdi-flash mdi-36px text-warning"></i>
              <div>
                <h6 class="fw-bold mb-1">
                  {{
                    tablehourlyData &&
                    tablehourlyData.length > 0 &&
                    tablehourlyData[0].EnergyConsumed != null
                      ? tablehourlyData[0].EnergyConsumed
                      : 0
                  }}KwH
                </h6>
                <p class="form-label mb-0">Energy</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card flex-fill">
        <div class="card-body">
          <div
            [options]="hourlyProductionChart"
            (chartInit)="onpartcounthourlyChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 150px"
            echarts
          ></div>
        </div>
      </div>
    </div>
    <div class="col-md-3 d-flex flex-column">
      <div class="card flex-fill">
        <div class="card-body">
          <div
            echarts
            [options]="productionChart"
            (chartInit)="onproductioncounthourlyChartInit($event)"
            class="chart-container"
            style="width: 100%; height: 100%; min-height: 200px"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div
            *ngIf="
              showTable &&
              (!tablehourlyData[0]?.hourArray ||
                tablehourlyData[0].hourArray.length === 0)
            "
            class="text-center text-muted"
          >
            Please wait, we are fetching data.
          </div>
          <div
            *ngIf="tablehourlyData[0]?.hourArray?.length > 0"
            class="table-responsive table-container"
          >
            <table
              class="table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0"
            >
              <thead class="thead-dark">
                <tr>
                  <th class="sticky-col">Parameter</th>
                  <th *ngFor="let hour of tablehourlyData[0].hourArray">
                    {{ hour }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of displayRows">
                  <td class="sticky-col">{{ row.label }}</td>
                  <td *ngFor="let val of tableData[0][row.key]">
                    {{
                      row.key === "Running" ||
                      row.key === "Idle" ||
                      row.key === "Breakdown" ||
                      row.key === "Interlock" ||
                      row.key === "Off" ||
                      row.key === "Downtime"
                        ? formatMinutesToHHMMSS(val)
                        : val
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            *ngIf="
              !showTable &&
              (!tablehourlyData[0]?.hourArray ||
                tablehourlyData[0].hourArray.length === 0)
            "
            class="text-center text-muted"
          >
            No data available for the selected Date and Depatment, as no
            production planning was scheduled.
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div *ngIf="!showTable" class="text-center text-muted">
            Please wait, we are fetching data.
          </div>
          <div *ngIf="showTable && tablehourlyData[0]?.hourArray?.length > 0" class="table-responsive table-container">
            <table class="table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0">
              <thead class="thead-dark">
                <tr>
                  <th>Hour</th>
                  <th>Part Name</th>
                  <th>Planned Part</th>
                  <th>Produced Part</th>
                  <th>Rejected Part</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let hour of tablehourlyData[0].hourArray; let i = index">
                  <ng-container *ngFor="let part of tablehourlyData[0].partwiseData; let j = index">
                    <tr>
                      <td *ngIf="j === 0" [attr.rowspan]="tablehourlyData[0].partwiseData.length">{{ hour }}</td>
                      <td>{{ part.partName }}</td>
                      <td>{{ part.Partplanned[i] }}</td>
                      <td>{{ part.Partcount[i] }}</td>
                      <td>{{ part.PartRejected[i] }}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
          </div>
          <div *ngIf="showTable && (!tablehourlyData[0]?.hourArray || tablehourlyData[0].hourArray.length === 0)"
            class="text-center text-muted">
            No data available for the selected Date and Depatment, as no production planning was scheduled.
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>

<ng-template #templatepdf role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }}</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click'); cancel()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <ul
        ngbNav
        #justifiednav="ngbNav"
        [activeId]="1"
        class="nav-pills nav-justified"
      >
        <li (click)="directExpo()" [ngbNavItem]="1">
          <a ngbNavLink>
            <h6 class="">Direct Export</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="directExport"></ng-template>
          </ng-template>
        </li>
        <li (click)="mailexport()" [ngbNavItem]="2">
          <a ngbNavLink>
            <h6 class="">Export via Email</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="mailExport"></ng-template>
          </ng-template>
        </li>
      </ul>
      &nbsp;&nbsp;
      <div [ngbNavOutlet]="justifiednav"></div>
      <div class="text-right mt-3">
        <button
          *ngIf="!exportViaMail"
          type="submit"
          class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()"
        >
          Export
        </button>
        <button
          *ngIf="exportViaMail"
          type="submit"
          class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()"
          [disabled]="!mailform.get('email').value"
        >
          Export
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #directExport>
  <form>
    <div>
      <p>Select the file type you would like to export</p>
    </div>
    <span
      class="pdf"
      [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"
      ><i class="fas fa-file-pdf" (click)="pdf()"> PDF </i></span
    >&nbsp;&nbsp;
    <span
      class="csv"
      [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"
      ><i class="fas fa-file-csv" (click)="csv()"> CSV </i></span
    >
    &nbsp;&nbsp;
  </form>
</ng-template>
<ng-template #mailExport>
  <div>
    <p>Select the file type you would like to export</p>
  </div>
  <span
    class="pdf"
    [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"
    ><i class="fas fa-file-pdf" (click)="pdf()"> PDF </i></span
  >&nbsp;&nbsp;
  <span
    class="csv"
    [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"
    ><i class="fas fa-file-csv" (click)="csv()"> CSV </i></span
  >&nbsp;&nbsp;
  <div>
    <form [formGroup]="mailform">
      <div class="form-group col-md-8">
        &nbsp;&nbsp;

        <input
          class="form-control"
          id="email"
          placeholder="user@gmail.com"
          formControlName="email"
          required
          [ngClass]="{ 'is-invalid': isEmailInvalid() }"
        />
        <div *ngIf="isEmailInvalid()">
          <span *ngIf="email.hasError('required')" style="color: red"
            >Email is required</span
          >
          <span *ngIf="email.hasError('email')" style="color: red"
            >Invalid email address</span
          >
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #templateallpdf role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }}</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click'); cancel()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div>
      <h6><b>Select the file type you would like to export data for all Machines.</b></h6>
    </div>
    <span
      class="pdf"
      [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"
      ><i class="fas fa-file-pdf" (click)="alldownload('pdf', modal)"> PDF </i></span
    >&nbsp;&nbsp;
    <span
      class="csv"
      [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"
      ><i class="fas fa-file-csv" (click)="alldownload('csv', modal)"> CSV </i></span
    >
  </div>
</ng-template>
